import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=474b5bf9&scoped=true"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=474b5bf9&prod&lang=scss"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=474b5bf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b5bf9",
  null
  
)

export default component.exports